import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { ISupportLanguage } from 'utils/types/storyTypes';
import { storyApi } from 'apis/story/storyApis';
import DefaultLayout from 'components/layout/DefaultLayout';
import { useAppDispatch } from 'hooks/redux';
import { setEditName, setStoryName } from 'store/slices/breadcumbSlice';
import { useCookies } from 'react-cookie';
import ContentWrapper from './ContentWrapper';
import { itemApis } from 'apis/package/itemApis';
import {
  fetchAbilityList,
  fetchItemTypeList,
  fetchProjectBgList,
  fetchProjectMinicutList,
  fetchProjectModelList,
  fetchSaleTypeList,
} from 'apis/common/commonApis';
import { loadingApis } from 'apis/story/loadingApis';

/**
 * *
 */

const LoadingImageEditPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const [cookies] = useCookies();

  const { projectId, loadingId } = useParams();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [data, setData] = useState<any | null>(null);

  const [supportLangList, setSupportLangList] = useState<
    ISupportLanguage[] | null
  >(null);

  const fetchDetailData = async () => {
    try {
      const storyDetailData = await storyApi.storyDetail(projectId);
      const dataRes = await loadingApis.loadingList(projectId);
      const langRes = await storyApi.supportLang();
      const detailData = dataRes.list.find((e) => e.id === Number(loadingId));

      setData(detailData);
      setSupportLangList(langRes);
      dispatch(setEditName(detailData.loading_name));

      const episodeName = storyDetailData?.project?.projectDetails?.find(
        (e) => e.lang === cookies.lang,
      );
      dispatch(
        setStoryName(episodeName ? episodeName.title : storyDetailData.title),
      );
    } catch (err) {
      console.log('fecth data error:', err);
    }
  };

  useEffect(() => {
    fetchDetailData();
  }, []);

  return (
    <>
      <DefaultLayout>
        <Wrapper>
          <ContentWrapper
            data={data}
            langList={supportLangList}
            setData={setData}
            projectId={projectId}
          />
        </Wrapper>
      </DefaultLayout>
    </>
  );
};

export default LoadingImageEditPage;

const Wrapper = styled.div`
  & > * + * {
    margin-top: 8rem;
  }
`;
